import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

window["paceOptions"] = {
  ajax: false,
  ghostTime: 11200,
  minTime: 11200,
  restartOnRequestAfter: false,
};

$.getJSON("./server_variables.json").then((json) => {
  window["server_variables"] = json;

  if (window["server_variables"].Production) {
    enableProdMode();
  }

  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
